import {
  animate,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ErrorMessageResource } from './models/index';

@Component({
  selector: 'mz-error-message',
  template: `<div [@enterAnimation]="errorMessage" class="invalid" *ngIf="(control.touched || control.dirty) && control.invalid && errorMessage">{{ errorMessage }}</div>`,
  styles: [`div.invalid{color:#e30613;font-size:.8rem;opacity:1;overflow-wrap:break-word}input:not([type=checkbox])+label+:host div.invalid,mz-select-container :host div.invalid,textarea+label+:host div.invalid{margin-top:-19px;min-height:19px}`],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({ transform: 'translateY(-5px)', opacity: 0 }),
          animate('300ms', style({ transform: 'translateY(0)', opacity: 1 })),
        ]),
        transition(':leave', [
          style({ transform: 'translateY(0)', opacity: 1 }),
          animate('300ms', style({ transform: 'translateY(-5px)', opacity: 0 })),
        ]),
      ],
    ),
  ],
})
export class MzErrorMessageComponent implements OnDestroy, OnInit {

  @Input() control: AbstractControl;
  @Input() errorMessageResource: ErrorMessageResource;

  controlStatusChangesSubscription: Subscription;
  errorMessage = '';

  ngOnInit() {
    this.buildErrorMessage();
    this.controlStatusChangesSubscription = this.control.statusChanges.subscribe(() => this.buildErrorMessage());
  }

  ngOnDestroy(): void {
    this.controlStatusChangesSubscription.unsubscribe();
  }

  buildErrorMessage() {
    this.errorMessage = '';
    if (this.control.errors && this.errorMessageResource) {
        Object.keys(this.control.errors).forEach(key => {
          this.errorMessage += this.errorMessageResource[key] + ' ';
        });
    }
  }
}
